/* @flow */
import React, {Component, PureComponent} from 'react'
import ReactDOM from 'react-dom'
import Select from 'antd/lib/select'
import Header from './ListHeader'
import ListDatePicker from './ListDatePicker'
import type {Funds, Lang, Mode, Sorter} from './App'
import labels from './labels'
import {CompensaRow, UfkRow, ViennaRow} from "./ListRow";
import Leaf from "./Leaf";
import {capitalize} from "./globals";

type State = {
  tableNode: ?HTMLElement
}

type Props = {
  selected: Set<string>,
  funds: Funds,
  limitReached: boolean,
  sorter: ?Sorter,
  asc: boolean,
  lang: Lang,
  grouped: 0 | 1,
  date: string,
  apiUrl: string,
  width: number,
  addData: (ids: Array<string>, () => void) => void,
  removeData: (ids: Set<string>) => void,
  sort: (sorter: Sorter) => (e: SyntheticEvent<>)=> void,
  changeDate: (date: Date) => void,
  manageGrouping: (grouped: 0 | 1) => void,
  mode: Mode
}

class List extends Component<Props, State> {
  state = {
    tableNode: null
  }
  componentDidMount () {
    const node = ReactDOM.findDOMNode(this)
    const tableNode = node instanceof HTMLElement ? node.querySelector('.ac-list-table') : null
    this.setState({ tableNode })
  }

  unselectAll = (): void => {
    const { removeData, selected } = this.props
    removeData(new Set(selected))
  }
  renderRows = () => {
    const { funds, selected, lang, limitReached, grouped, apiUrl, addData, removeData, width, mode } = this.props
    const renderedRows = []
    let prevCat = null
    for(const fund of funds) {
      const { category } = fund
      if (grouped && (!prevCat || prevCat !== category)) {
        renderedRows.push(<CategoryRow key={`cat${fund.id}`} category={category}/>)
        prevCat = category
      }
      if (mode === 'ufk') {
        renderedRows.push(
            <UfkRow
                key={fund.id}
                {...fund}
                lang={lang}
                disabled={limitReached && !selected.has(fund.id)}
                selected={selected.has(fund.id)}
                apiUrl={apiUrl}
                width={width}
                grouped={grouped}
                addData={addData}
                removeData={removeData}
                mode={mode}
            />)
      } else if (mode === 'compensa') {
        renderedRows.push(
            <CompensaRow
                key={fund.id}
                {...fund}
                lang={lang}
                disabled={limitReached && !selected.has(fund.id)}
                selected={selected.has(fund.id)}
                apiUrl={apiUrl}
                width={width}
                grouped={grouped}
                addData={addData}
                removeData={removeData}
                mode={mode}
            />)
      } else {
        renderedRows.push(
            <ViennaRow
                key={fund.id}
                {...fund}
                lang={lang}
                disabled={limitReached && !selected.has(fund.id)}
                selected={selected.has(fund.id)}
                apiUrl={apiUrl}
                width={width}
                grouped={grouped}
                addData={addData}
                removeData={removeData}
                mode={mode}
            />)
      }
    }
    return renderedRows
  }

  renderSfdrDesc = () => {
    const { funds, mode } = this.props;
    for (const fund of funds) {
        const { sfdrLevel } = fund;
        if (sfdrLevel && sfdrLevel > 0) {
          return (
              <table className="ui table">
                <tbody>
                <tr>
                  <td>
                    <div className="ui two column grid">
                      <div className="row">
                        <div className="one wide column center aligned"><Leaf/></div>
                        <div className="six wide column">Fundusz inwestycyjny, w którego jednostki uczestnictwa inwestuje UFK, promuje aspekt środowiskowy lub społeczny, lub oba te aspekty, spełniając kryteria, o których mowa w art. 8 Rozporządzenia SFDR, wpływając tym samym na klasyfikację UFK.</div>
                      </div>
                      { mode !== 'compensa' &&
                          <div className="row">
                            <div className="one wide column center aligned"><Leaf/><Leaf/></div>
                            <div className="six wide column">Fundusz inwestycyjny, w którego jednostki uczestnictwa inwestuje UFK, ma na celu zrównoważone inwestycje, spełniając kryteria, o których mowa w art. 9  Rozporządzenia SFDR, wpływając tym samym na klasyfikację UFK.</div>
                          </div>
                      }
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
          );
        }
    }
    return null;
  }

  renderCurrencyInfo = () => {
    const { mode } = this.props;
    return mode === 'vienna'
        ? (
        <table className="ui table">
          <tbody>
          <tr>
            <td>
              <div className="ui two column grid">
                <div className="row">
                  <div className="one wide column center aligned">(1)</div>
                  <div className="six wide column">Cena jednostki przeliczana jest na PLN/EURO według średniego kursu NBP pomniejszonego/powiększonego w zależności od typu operacji o 0,2%. Aktualny średni kurs Euro NBP znajduje się na stronie www.nbp.pl.</div>
                </div>
                <div className="row">
                  <div className="one wide column center aligned">(2)</div>
                  <div className="six wide column">Cena jednostki przeliczana jest na PLN/USD według średniego kursu NBP pomniejszonego/powiększonego w zależności od typu operacji o 0,2%. Aktualny średni kurs USD NBP znajduje się na stronie www.nbp.pl.</div>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table> )
        : null;
  }

  render () {
    const { sort, sorter, lang, changeDate, grouped, manageGrouping, asc, date, width, mode } = this.props
    const { tableNode } = this.state
    return (
      <div className="ac-list">
        <div className="ui grid">
          <div className="row ac-list__group-row">
            <div className={`left aligned bottom aligned ${width >= 768 ? 'seven' : 'six'} wide column`}>
              <GroupDropdown
                grouped={grouped}
                lang={lang}
                mode={mode}
                manageGrouping={manageGrouping}
              />
            </div>
            <div className={`right aligned bottom aligned ${width >= 768 ? 'six' : 'seven'} wide column`}>
              <span>{labels[lang].valOn} </span> <ListDatePicker date={date} changeDate={changeDate} />
            </div>
            <div className={`right aligned middle aligned ${width < 320 ? 'sixteen' : 'three'} wide column`}>
              <ToggleIcon element={tableNode}/>
            </div>
          </div>
        </div>
        <div className="ac-list-table">
          <table className={`ui celled definition sortable striped unstackable compact table ${grouped ? 'grouped' : ''}`}>
            <Header
              sort={sort}
              unselect={this.unselectAll}
              sorter={sorter}
              asc={asc}
              lang={lang}
              width={width}
              grouped={grouped}
              mode={mode}
            />
            <tbody>
              {this.renderRows()}
            </tbody>
          </table>
          {this.renderSfdrDesc()}
          {this.renderCurrencyInfo()}
        </div>
      </div>
    )
  }
}

export default List

type GroupDropdownProps = {
  grouped: 0 | 1,
  lang: Lang,
  mode: Mode,
  manageGrouping: (grouped: 0 | 1) => void
}

class GroupDropdown extends PureComponent<GroupDropdownProps> {
  onChange = (value: 0 | 1) => this.props.manageGrouping(value)

  render () {
    const { grouped, lang, mode } = this.props
    return (
      <div>
        <span>{labels[lang].display} </span>
        <Select className="ac-list__dropdown" defaultValue={grouped} onChange={this.onChange} style={{width: '14rem'}}>
          <Select.Option value={0}>{labels[lang].ungroup}</Select.Option>
          <Select.Option value={1}>{labels[lang]['group' + capitalize(mode)]}</Select.Option>
        </Select>
      </div>
    )
  }
}


class CategoryRow extends PureComponent<{ category: string }> {
  render () {
    const { category } = this.props
    return (
      <tr className="ac-list_category-row">
        <td colSpan="30">
          {category}
        </td>
      </tr>
    )
  }
}

export class ToggleIcon extends PureComponent<{ element: ?HTMLElement }, { display: boolean}> {
  state = {
    display: true
  }
  manageDisplay = () => {
    const { display } = this.state
    const { element } = this.props
    if (element) {
      const { classList } = element
      !classList.contains('collapsible') && classList.add('collapsible')
      display ? classList.add('ac-collapse') : classList.remove('ac-collapse')
    }
    this.setState({ display: !display })
  }
  render () {
    const { display } = this.state
    return (
      <i 
        aria-hidden="true"
        className={`chevron ${display ? 'down' : 'left'} large link icon collapse-icon`}
        onClick={this.manageDisplay}>
      </i>
    )
  }
}






// WEBPACK FOOTER //
// ./src/List.js